import React, { useState, createContext, useContext } from "react";
import "./Style.css";

// 전역 언어 컨텍스트
const LanguageContext = createContext();

// 언어 프로바이더 컴포넌트
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("ko");

  const value = {
    currentLanguage,
    setCurrentLanguage,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

// 언어 훅
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

// 언어 선택 컴포넌트
const LanguageSelector = ({ className = "", showLabel = true, size = "medium" }) => {
  const { currentLanguage, setCurrentLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const supportedLanguages = {
    ko: { name: "한국어", flag: "🇰🇷" },
    en: { name: "English", flag: "🇺🇸" },
    ja: { name: "日本語", flag: "🇯🇵" },
    zh: { name: "中文", flag: "🇨🇳" },
    es: { name: "Español", flag: "🇪🇸" },
    fr: { name: "Français", flag: "🇫🇷" },
    de: { name: "Deutsch", flag: "🇩🇪" },
    it: { name: "Italiano", flag: "🇮🇹" },
    pt: { name: "Português", flag: "🇵🇹" },
    ru: { name: "Русский", flag: "🇷🇺" },
  };

  const handleLanguageChange = (languageCode) => {
    if (languageCode !== currentLanguage) {
      setCurrentLanguage(languageCode);
      // 페이지 새로고침하여 모든 AutoTranslate 컴포넌트가 새 언어로 번역되도록 함
      window.location.reload();
    }
    setIsOpen(false);
  };

  const getCurrentLanguageInfo = () => {
    return supportedLanguages[currentLanguage] || supportedLanguages.ko;
  };

  return (
    <div className={`language-selector ${className} ${size}`}>
      {showLabel && <span className='language-label'>언어:</span>}
      <div className='language-dropdown'>
        <button className='language-button' onClick={() => setIsOpen(!isOpen)}>
          <span className='language-flag'>{getCurrentLanguageInfo().flag}</span>
          <span className='language-name'>{getCurrentLanguageInfo().name}</span>
          <span className='language-arrow'>▼</span>
        </button>

        {isOpen && (
          <div className='language-dropdown-menu'>
            {Object.entries(supportedLanguages).map(([code, info]) => (
              <button key={code} className={`language-option ${code === currentLanguage ? "active" : ""}`} onClick={() => handleLanguageChange(code)}>
                <span className='language-flag'>{info.flag}</span>
                <span className='language-name'>{info.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
